var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:(_vm.info.isExitRow ? 'small-map-block' : 'map-block') + ' exit exit-' + _vm.direction},[_c('span',{staticClass:"exit-text"})])
}
var staticRenderFns = []

export { render, staticRenderFns }